export default {
  name: 'PasswordCheckModal',

  data() {
    return {
      password: null,
      incorrectPassword: false
    };
  },

  methods: {
    submitForm() {
      // Emit an event with the password data
      if (this.password === '7654') {
        this.$emit('save', true);
      } else {
        this.incorrectPassword = true;
      }
    },
    close() {
      this.$emit('close');
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_modals/password-check/password-check-modal.js